<template>
    <div>
        <div class="panel mb-0">
            <div class="panel-hdr d-block pt-4 p-3">
                <div class="ml-auto mb-3 text-right">
                    <exportCSV class="link btn buttons-csv buttons-html5 btn-primary mr-2"
                        :data="exportData"
                        :fields="exportFields"
                        :header="exportHeaders"
                        type="csv"
                        :escapeCsv="false"
                        :name="exportFileName">
                        <span>CSV</span>
                    </exportCSV>
                    <!-- <button class="btn buttons-csv buttons-html5 btn-secondary ml-2" type="button" title="Generate PDF">
                        <span class="mr-3">PDF</span>
                        <i class="arrow-down fas fa-angle-down"></i> 
                    </button> -->
                </div>
                <div class="row mb-3">
                    <div class="col-sm-12 col-md-12 mb-2">
                        <b-form-group :label="$t('label.filter_by_date')" v-slot="{ ariaDescribedby }">
                            <b-form-radio-group class="mb-2"
                                id="dateFilterRadio"
                                v-model="selectedDateFilter"
                                :options="radDateFilter"
                                :aria-describedby="ariaDescribedby"
                                name="dateFilterRadio"
                            ></b-form-radio-group>
                        </b-form-group>
                    </div>
                    <div v-if="selectedDateFilter != 'all'" class="col-sm-12 col-md-3 mb-2">
                        <label class="form-label">{{$t(`tukang.${selectedDateFilter}_date`)}}</label>
                        <date-range-picker class="w-100"
                            ref="picker"
                            v-model="dateRange"
                            :opens="'right'"
                            :autoApply="true"
                            :showDropdowns="true" 
                            :always-show-calendars="false"
                            :locale-data="{firstDay: 1, format: 'dd/mm/yyyy'}"
                            @showCustomRange="showCustomRangeCalendars=true"
                            @update="filterByDate">
                        </date-range-picker>
                    </div>
                    <div class="col-sm-12 col-md-3 mb-2">
                        <div class="form-group">
                            <label class="form-label">{{$t('tukang.stylist')}}</label>
                            <div class="input-group">
                                <div class="input-group-prepend w-100">
                                    <label class="input-group-text border-right-0" >
                                        <i class="fas fa-user-friends"></i>
                                    </label>
                                    <multiselect v-model="selectedStylist" label="text" track-by="id" :options="stylist" :searchable="false" :show-labels="false" openDirection="below" @select="filterByStylist"></multiselect>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-3 mb-2">
                        <div class="form-group">
                            <label class="form-label">{{$t('header.post')}}</label>
                            <div class="input-group">
                                <div class="input-group-prepend w-100">
                                    <label class="input-group-text border-right-0" >
                                        <i class="fas fa-comment-alt"></i>
                                    </label>
                                    <multiselect v-model="selectedPost" :placeholder="$t('subMenu.my_salon_tukang') + $t('header.post')" label="title" track-by="id" :options="posts" :option-height="104" :custom-label="customLabel" :show-labels="false" @select="filterByPost">
                                        <template slot="singleLabel" slot-scope="props">
                                            <span class="option__desc"><span class="option__title">{{ props.option.title }}</span></span>
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            <div class="option__desc">
                                                <span v-if="props.option.id != 'all'" class="option__title d-block">{{'ID: ' + props.option.id }}</span>
                                                <span class="option__title d-block text-primary fw-500">{{ props.option.title == "" ? '-' : props.option.title }}</span>
                                                <span class="option__small fw-300 text-muted">{{ props.option.desc }}</span>
                                            </div>
                                        </template>
                                    </multiselect>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-3 mb-2">
                        <div class="form-group">
                            <label class="form-label">{{$t('subMenu.my_salon_member')}}</label>
                            <div class="input-group">
                                <div class="input-group-prepend w-100">
                                    <label class="input-group-text border-right-0" >
                                        <i class="fas fa-user"></i>
                                    </label>
                                    <multiselect v-model="selectedMember" :placeholder="$t('subMenu.my_salon_member')" label="text" track-by="id" :options="members" :option-height="104" :custom-label="customLabel" :show-labels="false" @select="filterByMember">
                                        <template slot="singleLabel" slot-scope="props">
                                            <span class="option__desc"><span class="option__title">{{ props.option.text }}</span></span>
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            <div class="option__desc">
                                                <span class="option__title d-block">{{props.option.text}}</span>
                                                <span v-if="props.option.mobile != ''" class="option__small fw-300 text-muted">
                                                    <i class="fal fa-phone-alt fs-sm"></i>
                                                    {{ props.option.mobile }}
                                                </span>
                                            </div>
                                        </template>
                                    </multiselect>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <a class="link text-primary" @click="clearFilter">{{$t('button_link.clear_filter')}}</a>
            </div>
            <div class="panel-container pb-3 show">
                <div class="panel-content">
                    <ul class="nav nav-tabs" role="tablist">
                        <li class="nav-item" v-for="c in $i18n.messages[$i18n.locale].tab.tukangOrderTabs" :key="c.id">
                            <a :class="{'active': selectedTab == c.id}" class="nav-link" role="tab" @click="filterByType(c.id)">{{c.text}}</a>
                        </li>
                    </ul>
                    <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
                        <b-spinner label="Loading..."></b-spinner>
                    </div>
                    <div class="panel-tag mt-3" v-if="!isSpinnerShow && totalEntries == 0">
                        {{$t('table.no_records')}}
                    </div>
                    <div v-if="!isSpinnerShow && totalEntries != 0" class="dataTables_wrapper dt-bootstrap4">
                        <div class="row justify-content-end mt-2">
                            <div class="col-auto pt-2">
                                <span>{{$t('table.pagination', {'startPage': startPage, 'endPage': endPage, 'totalEntries': totalEntries,})}}</span>
                            </div>
                            <div class="col-auto">
                                <b-pagination class="ml-3" v-model="currentPage" :per-page="perPage" :total-rows="totalEntries" @input="handlePagination" aria-controls="tblProductItems"></b-pagination>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 overflow-auto">
                                <b-table striped hover bordered :fields="fields" :items="orderItems" responsive="sm">
                                    <template #cell(index)="data">
                                        {{ data.index + startPage }}
                                    </template>
                                    <template #cell(TkOrderID)="data">
                                        {{insertLeadingZero(data.item.TkOrderID)}}
                                    </template>
                                    <template #cell(TkOrderCreateDate)="data">
                                        {{convertTimestampToDateTime(data.item.TkOrderCreateDate)}}
                                    </template>
                                    <template #cell(TkOrderPaidDate)="data">
                                        {{data.item.TkOrderPaidDate == 0 ? '-' : convertTimestampToDateTime(data.item.TkOrderPaidDate)}}
                                    </template>
                                    <template #cell(TkOrderRedeemDate)="data">
                                        {{data.item.TkOrderRedeemDate == 0 ? '-' : convertTimestampToDateTime(data.item.TkOrderRedeemDate)}}
                                    </template>
                                    <template #cell(TkOrderReimburseDate)="data">
                                        {{data.item.TkOrderReimburseDate == 0 ? '-' : convertTimestampToDateTime(data.item.TkOrderReimburseDate)}}
                                    </template>
                                    <template #cell(TkPostImage)="data">
                                        <b-carousel v-if="data.item.TkPostImage.length != 0"
                                            :interval="0"
                                            controls>
                                            <b-carousel-slide v-for="img in data.item.TkPostImage" :key="img.id"
                                                img-height="240"
                                                :img-src="img.src"
                                            ></b-carousel-slide>
                                        </b-carousel>
                                        <span v-else>-</span>
                                    </template>
                                    <template #cell(TkPostName)="data">
                                        <p class="fw-500 text-primary mb-1">{{data.item.TkPostName == '' ? '-' : data.item.TkPostName}}</p>
                                        <div v-if="data.item.TkPostDetails != ''">
                                            <span class="fw-400" style="text-decoration: underline">{{$t('label.details')}}:</span>
                                            <span class="fw-300 text-muted details-overflow">{{data.item.TkPostDetails}}</span>
                                        </div>
                                    </template>
                                    <!-- <template #cell(TkPostPrice)="data">
                                        {{formatPrice(data.item.TkPostPrice)}}
                                    </template> -->
                                    <template #cell(TkOrderDiscount)="data">
                                        <div v-if="data.item.TkOrderDiscountCode != '' && data.item.TkOrderDiscountCodeAmt != 0">
                                            <span class="badge badge-warning">{{data.item.TkOrderDiscountCode}}</span>
                                            <span class="d-block">{{formatPrice(data.item.TkOrderDiscountCodeAmt)}}</span>
                                        </div>
                                        <span v-else>
                                            {{formatPrice(data.item.TkOrderDiscountCodeAmt)}}
                                        </span>
                                    </template>
                                    <template #cell(TkOrderPrice)="data">
                                        <flag :iso="data.item.DfCurrency == 'MYR' ? 'my' : 'sg'" class="mr-1"/>{{data.item.DfCurrency}}
                                        <span class="mb-0 mr-2 fw-400 d-block">{{formatPrice(data.item.TkOrderPrice)}}</span>
                                        <span v-if="data.item.TkPostPrice !=  data.item.TkOrderPrice"  class="mb-0 text-secondary fw-300 fs-xs" style="text-decoration: line-through">{{data.item.TkPostPrice}}</span>
                                    </template>
                                    <template #cell(address)="data">
                                        <div v-if="data.item.GeoAddrGeoLine1 == ''
                                                && data.item.GeoAddrGeoLine2 == ''
                                                && data.item.GeoAddrGeoPostalCode == ''
                                                && data.item.GeoAddrGeoCity == ''">-
                                        </div>
                                        <div v-else>
                                            <span class="d-block" v-if="data.item.GeoAddrGeoLine1 != ''">{{data.item.GeoAddrGeoLine1}}</span>
                                            <span class="d-block" v-if="data.item.GeoAddrGeoLine2 != ''">{{data.item.GeoAddrGeoLine2}}</span>
                                            <span class="d-block" v-if="data.item.GeoAddrGeoPostalCode != ''">{{data.item.GeoAddrGeoPostalCode}}, </span>
                                            <span class="d-block" v-if="data.item.GeoAddrGeoCity != ''">{{data.item.GeoAddrGeoCity}}.</span>
                                        </div>
                                    </template>
                                </b-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
import DateRangePicker from 'vue2-daterange-picker'
import {formatPrice, insertLeadingZero} from './../../../../assets/js/dashboard/utilities'
import {setReturnData, handleSessionExpired,} from './../../../../assets/js/dashboard/dashboard'
export default {
    name: 'tukangOrder',
    components:{
        DateRangePicker
    },
    data(){
        let now = moment();
        let startDate = now.startOf('month').toDate();
        let endDate = now.endOf('month').toDate()
        return{
            isSpinnerShow: false,
            selectedDateFilter: 'create',
            selectedTab: 'all',
            stylist: [],
            selectedStylist: {id: 'all', text: this.$i18n.t('label.all', {'item': this.$i18n.t('tukang.stylist')})},
            members: [],
            selectedMember: {id: 'all', text: this.$i18n.t('label.all', {'item': this.$i18n.t('subMenu.my_salon_member')})},
            posts: [],
            selectedPost: {id: 'all', title: this.$i18n.t('label.all', {'item': this.$i18n.t('header.post')})},
            dateRange: { startDate, endDate },
            orderItems: [],
            page: 0, totalEntries: 0, totalPage: 0, startPage: 1, endPage: 0, perPage: 100, currentPage: 1,
            exportHeaders: [], exportData: [], exportFileName: "" , orderExportData: []
        }
    },
    computed:{
        radDateFilter(){
            return[{ "text": this.$i18n.t('tukang.create_date'), "value": "create" },
                { "text": this.$i18n.t('tukang.paid_date'), "value": "paid" },
                { "text": this.$i18n.t('tukang.redeem_date'), "value": "redeem" },
                { "text": this.$i18n.t('tukang.reimburse_date'), "value": "reimburse" },
                { "text": this.$i18n.t('label.all', {'item': ''}), "value": "all" },
            ]
        },
        fields(){
            var arr = [
                { key: "index", label: "#", thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
                { key: "TkOrderID", label: this.$i18n.t('table.header.order_id'), thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true},
                { key: "TkOrderCreateDate", label: this.$i18n.t('tukang.create_date'), thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true},
            ]
            if(this.selectedDateFilter == 'all'){
                var dateArr = [
                    { key: "TkOrderPaidDate", label: this.$i18n.t('tukang.paid_date'), thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true},
                    { key: "TkOrderRedeemDate", label: this.$i18n.t('tukang.redeem_date'), thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true},
                    { key: "TkOrderReimburseDate", label: this.$i18n.t('tukang.reimburse_date'), thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true}
                ]
                arr.push(...dateArr)
            }else{
                if(this.selectedDateFilter != 'order'){
                    var obj = {
                        key: "TkOrder" + this.selectedDateFilter.charAt(0).toUpperCase() + this.selectedDateFilter.slice(1) + "Date",
                        label: this.$i18n.t(`tukang.${this.selectedDateFilter}_date`),
                        thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true
                    }
                    arr.push(obj)
                }
            }
            var _arr = [
                { key: "TkPostImage", label: this.$i18n.t('label.image'), thClass: 'thead-themed align-middle', tdClass: 'align-middle td-img-width'},
                { key: "TkOrderPrice", label: this.$i18n.t('tukang.order_price'), thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true},
                { key: "TkOrderDiscount", label: this.$i18n.t('subMenu.salon_menu_discount'), thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
                { key: "TkPostName", label: this.$i18n.t('table.header.title'), thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true}, 
                { key: "TkStylistName", label: this.$i18n.t('tukang.stylist'), thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true},
                { key: "memberName", label: this.$i18n.t('subMenu.my_salon_member') + this.$i18n.t('label.name'), thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true},
                { key: "mobile", label: this.$i18n.t('table.header.contact'), thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
                { key: "address", label: this.$i18n.t('header.address'), thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
                // { key: "TkPostPrice", label: this.$i18n.t('tukang.post_price'), thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true},
                
            ]
            arr.push(..._arr)
            return arr
        },
        exportFields(){
            var ret = {}
            ret["#"] = "index"
            ret[this.$i18n.t('table.header.order_id').toUpperCase()] = "orderID"
            ret[this.$i18n.t('tukang.create_date').toUpperCase()] = "orderDate"
            if(this.selectedDateFilter == 'all'){
                ret[this.$i18n.t('tukang.paid_date').toUpperCase()] = "paidDate"
                ret[this.$i18n.t('tukang.redeem_date').toUpperCase()] = "redeemDate"
                ret[this.$i18n.t('tukang.reimburse_date').toUpperCase()] = "reimburseDate"
            }else{
                if(this.selectedDateFilter != 'order'){
                   ret[this.$i18n.t(`tukang.${this.selectedDateFilter}_date`).toUpperCase()] = this.selectedDateFilter + "Date"
                }
            }
            ret[this.$i18n.t('table.header.title').toUpperCase()] = "postName"
            ret[this.$i18n.t('label.details').toUpperCase()] = "details"
            ret[this.$i18n.t('tukang.stylist').toUpperCase()] = "stylistName"
            ret[(this.$i18n.t('subMenu.my_salon_member') + this.$i18n.t('label.name')).toUpperCase()] = "memberName"
            // ret[this.$i18n.t('tukang.post_price').toUpperCase()] = "postPrice"
            ret[this.$i18n.t('table.header.contact').toUpperCase()] = "mobile"
            ret[this.$i18n.t('tukang.order_price').toUpperCase()] = "orderPrice"
            return ret
        }
    },
    watch:{
        selectedDateFilter(val){
            this.filterTukangOrder()
        },
        "$i18n.locale"(val){
            
            this.stylist[0].text = this.$i18n.t('label.all', {'item': this.$i18n.t('tukang.stylist')})
            var b = Object.assign({}, this.selectedStylist)
            this.selectedStylist = this.stylist.filter(obj=> obj.id == b.id)[0]

            this.posts[0].title = this.$i18n.t('label.all', {'item': this.$i18n.t('header.post')})
            var a = Object.assign({}, this.selectedPost)
            this.selectedPost = this.posts.filter(obj=> obj.id == a.id)[0]

            this.members[0].text = this.$i18n.t('label.all', {'item': this.$i18n.t('subMenu.my_salon_member')})
            var c = Object.assign({}, this.selectedMember)
            this.selectedMember = this.members.filter(obj=> obj.id == c.id)[0]
            
            this.setExportData(this.orderExportData)
        }
    },
    methods:{
        insertLeadingZero(number){
            return insertLeadingZero(number);
        },
        formatPrice(price){
            return formatPrice(parseFloat(price));
        },
        convertTimestampToDateTime(ts){
            return moment.unix(ts).format(this.$msg.CST.DATE_TIME_24)
        },
        customLabel ({ title, desc }) {
            return `${title} – ${desc}`
        },
        clearFilter(){
            let now = moment();
            let startDate = now.startOf('month').toDate();
            let endDate = now.endOf('month').toDate()
            this.dateRange = {startDate, endDate}
            this.selectedTab = 'all'
            this.selectedDateFilter = 'create'
            this.selectedStylist = {id: 'all', text: this.$i18n.t('label.all', {'item': this.$i18n.t('tukang.stylist')})}
            this.selectedPost = {id: 'all', title: this.$i18n.t('label.all', {'item': this.$i18n.t('header.post')})}
            this.selectedMember = {id: 'all', text: this.$i18n.t('label.all', {'item': this.$i18n.t('subMenu.my_salon_member')}), mobile: ''}

            this.filterTukangOrder()
        },
        filterByDate(date){
            date.startDate = moment(date.startDate).startOf('day')
            date.endDate = moment(date.endDate).endOf('day')
            this.dateRange = date
            this.filterTukangOrder()
        },
        filterByType(id){
            this.selectedTab = id
            this.filterTukangOrder()
        },
        filterByMember(item){
            this.selectedMember = item
            this.filterTukangOrder()
        },
        filterByStylist(item){
            this.selectedStylist = item
            this.filterTukangOrder()
        },
        filterByPost(item){
            this.selectedPost = item
            this.filterTukangOrder()
        },
        filterTukangOrder(){
            var dateFilter = this.selectedDateFilter != 'all' ? 
                '&startTkOrder' + this.selectedDateFilter.charAt(0).toUpperCase() + this.selectedDateFilter.slice(1) + "Date=" +
                moment(this.dateRange.startDate).unix() + 
                '&endTkOrder' + this.selectedDateFilter.charAt(0).toUpperCase() + this.selectedDateFilter.slice(1) + "Date=" +
                moment(this.dateRange.endDate).unix() 
            : ""
            var typeFilter = this.selectedTab == 'all' ? "" : '&' + this.selectedTab + '=1'
            var stylistFilter = this.selectedStylist.id == 'all' ? '' : '&TkStylistID=' + this.selectedStylist.id
            var postFilter = this.selectedPost.id == 'all' ? '' : '&TkPostID=' + this.selectedPost.id
            var memberFilter = this.selectedMember.id == 'all' ? '' : '&memberID=' + this.selectedMember.id

            let QUERY_STRING = dateFilter + typeFilter + stylistFilter + postFilter + memberFilter
            this.setTukangOrder(QUERY_STRING)
        },
        setMemberOptions(items){
            this.members = [{id: 'all', text: this.$i18n.t('label.all', {'item': this.$i18n.t('subMenu.my_salon_member')}), mobile: ''}]
            items.forEach(a => this.members.some(b => b.id === a.memberID) || this.members.push({id: a.memberID, text: a.memberName, mobile: a.mobile}));
        },
        setStylistOption(items){
            this.stylist = [{id: 'all', text: this.$i18n.t('label.all', {'item': this.$i18n.t('tukang.stylist')})}]
            items.forEach(a => this.stylist.some(b => b.id === a.TkStylistID) || this.stylist.push({id: a.TkStylistID, text: a.TkStylistName}));
        },
        setPostOption(items){
            this.posts = [{id: 'all', title: this.$i18n.t('label.all', {'item': this.$i18n.t('header.post')})}]
            items.forEach(a => this.posts.some(b => b.id === a.TkPostID) || this.posts.push(
                {
                    id: a.TkPostID, 
                    title: a.TkPostName,
                    desc: a.TkPostDetails
                }
            ));
        },
        handlePagination(pg){
            if(pg != null){
                this.page = pg - 1
                this.filterTukangOrder();
            }
        },
        async setTukangOrder(strFilter){
            this.isSpinnerShow = true
            var result = await this.getTukangOrder("?page=" + this.page + strFilter)
            var data = result.result
            
            if(this.selectedMember.id == 'all'){
                this.setMemberOptions(data)
            }
            if(this.selectedStylist.id == 'all'){
                this.setStylistOption(data)
            }
            if(this.selectedPost.id == 'all'){
                this.setPostOption(data)
            }

            var items = []
            for(var i=0; i<data.length; i++){
                var image = []
                for(var j=1; j<=6; j++){
                    var key = "TkPostImage" + j
                    if(data[i][key] != ""){
                        image.push({
                            id: key,
                            src: data[i][key],
                            thumbnail: data[i][key],
                        })
                    }
                }
                items.push({
                    DfCurrency: data[i].DfCurrency,
                    TkOrderCreateDate: data[i].TkOrderCreateDate,
                    TkOrderRedeemDate: data[i].TkOrderRedeemDate,
                    TkOrderReimburseDate: data[i].TkOrderReimburseDate,
                    TkOrderPaidDate: data[i].TkOrderPaidDate,
                    TkOrderID: data[i].TkOrderID,
                    TkPostImage: image,
                    TkPostName: data[i].TkPostName,
                    TkPostDetails: data[i].TkPostDetails,
                    TkStylistName: data[i].TkStylistName,
                    TkStylistID: data[i].TkStylistID,
                    TkOrderPrice: data[i].TkOrderPrice,
                    TkOrderDiscountCode: data[i].TkOrderDiscountCode,
                    TkOrderDiscountCodeAmt: data[i].TkOrderDiscountCodeAmt,
                    TkPostPrice: data[i].TkPostPrice,
                    shopID: data[i].shopID,
                    TkCompanyID: data[i].TkCompanyID,
                    memberID: data[i].memberID,
                    memberName: data[i].memberName,
                    mobile: data[i].mobile,
                    GeoAddrGeoName: data[i].GeoAddrGeoName,
                    GeoAddrGeoLine1: data[i].GeoAddrGeoLine1,
                    GeoAddrGeoLine2: data[i].GeoAddrGeoLine2,
                    GeoAddrGeoPostalCode: data[i].GeoAddrGeoPostalCode,
                    GeoAddrGeoCity: data[i].GeoAddrGeoCity,
                })
            }

            var retData = setReturnData(items, result.count, this.page)
            this.orderItems = retData.result;
            this.orderItems.sort((a, b) => b.TkOrderCreateDate - a.TkOrderCreateDate);
            this.totalEntries = retData.count;
            this.totalPage = retData.totalPage;

            this.startPage = retData.startPage;
            this.endPage = retData.endPage;
            this.isSpinnerShow = false

            var expResult = await this.getTukangOrder("?" + strFilter)
            this.orderExportData = expResult.result
            this.setExportData(this.orderExportData)
        },
        setExportData(data){
            this.exportData = []

            let header = this.$msg.REPORT.HEADER + this.$i18n.t(`subMenu.my_salon_tukang`) + this.$i18n.messages[this.$i18n.locale].tab.tukangTabs[2].text
            this.exportHeaders = [
                header, 
                this.$i18n.t('label.filter_by_date') + ": " + (this.selectedDateFilter == 'all' ? this.$i18n.t('label.all', {'item': ''}) : this.$i18n.t(`tukang.${this.selectedDateFilter}_date`)),
                this.$i18n.t('table.report_generate') + moment().format(this.$msg.CST.DATE_TIME_24),
                " "];
            this.exportFileName =  header.split(" ").join("_") +  this.$msg.REPORT.CSV

            for(var i=0; i<data.length; i++){
                var obj = {
                    index: i+1,
                    orderDate: this.convertTimestampToDateTime(data[i].TkOrderCreateDate),
                }
                if(this.selectedDateFilter != 'all'){
                    if(this.selectedDateFilter != 'order'){
                        var key = "TkOrder" + this.selectedDateFilter.charAt(0).toUpperCase() + this.selectedDateFilter.slice(1) + "Date"
                        obj[this.selectedDateFilter + 'Date'] = data[i][key] == 0 ? '-' : this.convertTimestampToDateTime(data[i][key])
                    }
                }else{
                    obj.paidDate = data[i].TkOrderPaidDate == 0 ? '-' : this.convertTimestampToDateTime(data[i].TkOrderPaidDate)
                    obj.redeemDate = data[i].TkOrderRedeemDate == 0 ? '-' : this.convertTimestampToDateTime(data[i].TkOrderRedeemDate)
                    obj.reimburseDate = data[i].TkOrderReimburseDate == 0 ? '-' : this.convertTimestampToDateTime(data[i].TkOrderReimburseDate)
                }

                obj.postName = data[i].TkPostName == "" ? "-" : data[i].TkPostName
                obj.details = data[i].TkPostDetails == "" ? "-" : data[i].TkPostDetails
                obj.stylistName = data[i].TkStylistName
                obj.memberName = data[i].memberName
                obj.mobile = data[i].mobile
                obj.postPrice = data[i].TkPostPrice
                obj.orderPrice = data[i].TkOrderPrice

                this.exportData.push(obj)
            }
        },
        async getTukangOrder(strFilter){
            let $vm = this;
            const url =  this.$api.TUKANG_ORDER + strFilter 

            var result = {}
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result= response.data
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            return result
        },
    },
    mounted(){
        let $vm = this
        $vm.setTukangOrder("")
    }
}
</script>
<style scoped>
.details-overflow{
    display: block; /* Fallback for non-webkit */
    display: -webkit-box;
    max-width: 20em;
    margin: 0 auto;
    line-height: 1.4;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}
.limit-line{
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>